import classJoin from 'classjoin';
import {h} from 'preact';
import FilterForm from './FilterForm';
import {SubscribedComponent} from './Store/index';
import State from './Store/State';

/**
 * Component Properties.
 */
interface VisualFilterProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface VisualFilterState
{
	/** Фильтр показан? */
	filterVisible: boolean;
}

class VisualFilter extends
	SubscribedComponent<State, VisualFilterProps, VisualFilterState>
{
	public constructor( props: VisualFilterProps )
	{
		super( props );
	}
	
	/**
	 * Before render, return false to skip render.
	 */
	public shouldComponentUpdate(
		_props: VisualFilterProps,
		{filterVisible}: VisualFilterState,
	): boolean
	{
		if (
			( filterVisible === this.state.filterVisible )
		)
		{
			return false;
		}
		
		return true;
	}
	
	/**
	 * Render component.
	 */
	public render(
		_props: VisualFilterProps,
		{filterVisible}: VisualFilterState,
	): JSX.Element
	{
		return (
			<div
				class={
					classJoin(
						{
							visible: filterVisible,
						},
						['filter'],
					)
				}
			>
				<h1>Выбрать квартиру</h1>
				<FilterForm />
			</div>
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{
			visualData: {
				filterVisible,
			},
		}: State,
	): void
	{
		if (
			( filterVisible === this.state.filterVisible )
		)
		{
			return;
		}
		
		this.setState( {filterVisible} );
	}
}

/**
 * Module.
 */
export {
	VisualFilter as default,
	VisualFilterProps,
	VisualFilterState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/VisualFilter.tsx